import { View, StyleSheet, ImageBackground } from "react-native";
import React from "react";
import { Image } from "expo-image";
import { getSanityImage } from "lib/sanity";
import { ShopPage } from "lib/sanity.types";
import Button from "components/Button";
import PortableText from "./components/PortableText";
import { useFetchTenantBrandingQuery } from "queries/tenant.queries";
import Container from "components/Container";

const HeroSection = ({ shopPage }: { shopPage: ShopPage }) => {
  const { data: branding } = useFetchTenantBrandingQuery();

  return (
    <ImageBackground
      source={{
        uri: getSanityImage(shopPage.heroSectionBackgroundImage.asset._ref),
      }}
      className="flex-grow bg-cover bg-no-repeat"
    >
      <View
        style={[
          StyleSheet.absoluteFillObject,
          {
            backgroundColor: branding?.primaryColor,
            opacity: 0.8,
          },
        ]}
      ></View>
      <Container className="py-4 md:py-32">
        <View className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-4">
          <View className=" text-white">
            <PortableText value={shopPage.heading}></PortableText>
            {shopPage.showCtaButton && (
              <Button className="mt-5 self-start " appearance="outline">
                {(props) => (
                  //@ts-ignore
                  <a
                    {...props}
                    className="text-black no-underline"
                    href="#plans"
                  >
                    Get Started
                  </a>
                )}
              </Button>
            )}
          </View>
          {shopPage.productPreviewImage !== undefined && (
            <Image
              style={{ maxWidth: 500, height: 250 }}
              source={{
                uri: getSanityImage(shopPage.productPreviewImage.asset._ref),
              }}
              responsivePolicy="initial"
              contentFit="contain"
              alt="product preview image"
            ></Image>
          )}
        </View>
      </Container>
    </ImageBackground>
  );
};

export default HeroSection;
